import Marquee from "react-fast-marquee";
import { Reveal } from "../site/Motion";
import { SectionLabel } from "../site/Bits";
import { INDUSTRIES } from "../../lib/site";

export const IndustriesMarquee = () => (
  <section className="relative bg-white py-20" data-testid="industries-section">
    <div className="mx-auto mb-10 max-w-7xl px-5 text-center lg:px-8">
      <Reveal className="flex flex-col items-center">
        <SectionLabel>Industries we serve</SectionLabel>
        <h2 className="mt-5 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl">
          Trusted across every kind of business.
        </h2>
      </Reveal>
    </div>

    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-white to-transparent" />
      <Marquee speed={40} gradient={false} autoFill pauseOnHover>
        {INDUSTRIES.map((n) => (
          <span
            key={n}
            className="mx-4 inline-flex items-center gap-3 rounded-full border border-slate-200 bg-background px-7 py-3 font-display text-lg font-medium text-slate-700"
          >
            <span className="h-2 w-2 rounded-full bg-greenaccent" />
            {n}
          </span>
        ))}
      </Marquee>
    </div>
  </section>
);

export default IndustriesMarquee;
